import Vuex from "vuex"
import Vue from "vue"
import reportStore from '../store/reportSotre'
Vue.use(Vuex)
const store = new Vuex.Store({
  state:{
    UserLogin:false,
    UserInfo:{},
    AppId:0,
    AppList:[],
    AppAll:[],
    Country:[],
    SpendChannel:[],
    RevenueChannel:[],
    AdType:[],
    purchaseAccount:{
      'APPLE香港':'mobibrain.tec@outlook.com',
      'APPLE武汉':'xialinwei@hellowd.net',
      'APPLE国内':'研发内部账号',
      'fisheater':'外部账号',
      '甜点':'yujiuganghelloworld@gmail.com',
      '瘦身香港':'hotgamesteam.hw@gmail.com',
      '大陆主体':'hotgamesteam@gmail.com',
    },
    RevenueChange:{
      'pangle':'国内穿山甲 乘0.9366',
      'smaato':'2022-08-01前 乘0.7 ，后 乘0.75',
      'unity':'乘0.98, 2024-04-01 后 商业化部门更新修正系数',
      'ironSource':'2022-11-01 后 乘0.98, 2024-04-01 后 商业化部门更新修正系数',
      'google':'预处理：乘0.98，25号后商业化部门更新修正系数',
      'facebook':'25号后商业化部门更新修正系数',
      'aps':'2023-06-01 起 拉取相关数据，乘 0.91',
    }
  },
  mutations:{
    setUserLogin(state,login){
      state.UserLogin = login
    },
    setUserInfo(state,userInfo){
      state.UserInfo = userInfo
    },
    setAppId(state,appId){
      state.AppId = appId
      localStorage.setItem('app_id',appId)
    },
    setAppList(state,appList){
      state.AppList = appList
    },
    setAppAll(state,appAll){
      state.AppAll = appAll
    },
    setCountry(state,country){
      state.Country = country
    },
    setSpendChannel(state,spendChannel){
      state.SpendChannel = spendChannel
    },
    setRevenueChannel(state,revenueChannel){
      state.RevenueChannel = revenueChannel
    },
    setAdType(state,adType){
      state.AdType = adType
    }
  },
  getters:{
    getUserLogin:state => {
      return state.UserLogin
    },
    getUserInfo:state => {
      return state.UserInfo
    },
    getAppId:state => {
      return state.AppId
    },
    getAppInfo:state => {
      let _index = state.AppList.findIndex(item=>{
        return item.app_id===state.AppId
      })
      if (_index!==-1) return state.AppList[0]
      return {app_name:''}
    },
    getAppList:state => {
      return state.AppList
    },
    getAppAll:state => {
      return state.AppAll
    },
    getCountry:state => {
      return state.Country
    },
    getSpendChannel:state => {
      return state.SpendChannel
    },
    getRevenueChannel:state => {
      return state.RevenueChannel
    },
    getAdType:state => {
      return state.AdType
    }
  },
  actions:{},
  modules:{
    report:reportStore,
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js